import Dropzone from "dropzone";
import $ from "jquery";
import { setMaxListeners } from "process";

const filesDropzoneElementId = ".modal #frm-suggestion-files-dropzone";
const filesDropzoneElementBlockId = ".block #frm-suggestion-files-dropzone";
let filesDropzone;
let filesDropzoneBlock;
var defaultMsg = "Kliknite alebo pretiahnite prílohy";
var overlimitMsg1 = "Táto príloha je príliš veľká ";
var overlimitMsg2 = "maximálna veľkosť je  ";

if ($(filesDropzoneElementId).length > 0) {
  if ($(filesDropzoneElementId).data("lang") != "sk") {
    defaultMsg = "Tap or drop files";
    overlimitMsg1 = "This file is big ";
    overlimitMsg2 = "maximal size of file is  ";
  }

  filesDropzone = new Dropzone(filesDropzoneElementId, {
    url: `${SITE_PARAMS.site_url}/wp-json/kvop/v1/upload`,
    paramName: "files",
    maxFilesize: 10,
    dictDefaultMessage: defaultMsg,
    dictFileTooBig:
      "{{overlimitMsg1}}( {{filesize}}MB), {{overlimitMsg2}} {{maxFilesize}}MB",
    dictCancelUpload: "Přerušit nahrávání",
    dictRemoveFile: "Odstranit fotku",
    addRemoveLinks: true,
  });

  filesDropzone.on("success", function (file, response) {
    if (response.status == true) {
      // succeeded
      return file.previewElement.classList.add("dz-success"); // from source
    } else if (response.status == false) {
      //  error
      // below is from the source code too
      var node, _i, _len, _ref, _results;
      var message = myresponse.msg; // modify it to your error message
      file.previewElement.classList.add("dz-error");
      file.previewElement.classList.remove("dz-success");
      _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        node = _ref[_i];
        _results.push((node.textContent = message));
      }
      return _results;
    }
  });

  filesDropzone.on("removedfile", function (file) {
    removeFile({ file: file.name });
  });
}

console.log($(filesDropzoneElementBlockId));
if ($(filesDropzoneElementBlockId).length > 0) {
  if ($(filesDropzoneElementBlockId).data("lang") != "sk") {
    defaultMsg = "Tap or drop files";
    overlimitMsg1 = "This file is big ";
    overlimitMsg2 = "maximal size of file is  ";
  }

  filesDropzoneBlock = new Dropzone(filesDropzoneElementBlockId, {
    url: `${SITE_PARAMS.site_url}/wp-json/kvop/v1/upload`,
    paramName: "files",
    maxFilesize: 10,
    dictDefaultMessage: defaultMsg,
    dictFileTooBig:
      "{{overlimitMsg1}}( {{filesize}}MB), {{overlimitMsg2}} {{maxFilesize}}MB",
    dictCancelUpload: "Přerušit nahrávání",
    dictRemoveFile: "Odstranit fotku",
    addRemoveLinks: true,
  });

  filesDropzoneBlock.on("success", function (file, response) {
    if (response.status == true) {
      // succeeded
      return file.previewElement.classList.add("dz-success"); // from source
    } else if (response.status == false) {
      //  error
      // below is from the source code too
      var node, _i, _len, _ref, _results;
      var message = myresponse.msg; // modify it to your error message
      file.previewElement.classList.add("dz-error");
      file.previewElement.classList.remove("dz-success");
      _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        node = _ref[_i];
        _results.push((node.textContent = message));
      }
      return _results;
    }
  });

  filesDropzoneBlock.on("removedfile", function (file) {
    removeFile({ file: file.name });
  });
}

const removeFile = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + "/wp-json/kvop/v1/upload/remove",
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export function removeSuggestionUploads(serverData = false) {
  if (filesDropzone != undefined) filesDropzone.removeAllFiles();
  if (filesDropzoneBlock != undefined) filesDropzoneBlock.removeAllFiles();
  // if (serverData == true){
  //   var filter = {all: true};
  //   removeFile(filter)
  // }
}
